export default "__VITE_ASSET__BOQt_4u8__"